import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BazisModalService } from '@bazis/shared/services/modal.service';
import { EntData } from '@bazis/shared/models/srv.types';
import { DocumentAccordeonComponent } from '@bazis/shared/components/document-accordeon/document-accordeon.component';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { LinkModule } from '@bazis/shared/components/web/link/link.module';
import { TranslocoModule } from '@jsverse/transloco';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'bazis-docu-signatures',
    templateUrl: './docu-signatures.component.html',
    imports: [
        DocumentAccordeonComponent,
        IconModule,
        LinkModule,
        TranslocoModule,
        ColorDirective,
        CommonModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BazisDocuSignaturesComponent implements OnInit {
    @Input() signInfo: EntData;

    @Input() document: EntData;

    @Input() documentName: string;

    @Input() site: string = location.host;

    isScrollingContent: boolean = false;

    openDropdownMenu = false;

    constructor(public modalService: BazisModalService) {}

    ngOnInit() {
        console.log(this.signInfo);
    }

    onContentScroll(ev) {
        const scrollPosition = ev.target.scrollTop;
        this.isScrollingContent = scrollPosition > 50 ? true : false;
    }
}
